<template>
  <CustomSelect
    class="w-100"
    inputId="orderStatusPicker"
    inputLabel="وضعیت سفارش"
    :customOptions="filteredOrderStatusOptions"
    :value="value"
    @input="$emit('input', $event)"
  >
  </CustomSelect>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, null],
      default: null,
    },
    doesHaveAllOption: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      orderStatusOptions: [
        {
          value: null,
          text: "همه",
        },
        {
          value: 1,
          text: "ثبت شده",
        },
        {
          value: 2,
          text: "پرداخت شده",
        },
        {
          value: 5,
          text: "کنسل شده",
        },
      ],
    };
  },
  computed: {
    filteredOrderStatusOptions() {
      let orderStatusOptions = this.orderStatusOptions;
      if (!this.doesHaveAllOption) {
        orderStatusOptions = this.orderStatusOptions.filter((status) => {
          return status.value;
        });
      }
      return orderStatusOptions;
    },
  },
  components: {
    CustomSelect,
  },
};

import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
